import React, {PureComponent} from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import userActions from 'redux/actions/userActions'

class UpgradeConfirm extends PureComponent {

	actionSelected(button) {
		this.props.actions.userUpgradeActionSelected(this.props.upgrade_data, button)
	}

	render() {

		const props = this.props
		const buttons = props.upgrade_data.buttons
		const closeButtonData = {action: '99'}

		return (<Confirm
			btTwo={buttons[1].text}
			btOne={buttons[0].text}
			alertTitle={props.upgrade_data.offerTitle}
			alertMessage={props.upgrade_data.offerMessage}
			actionButtonType={0}
			centeredTitle={true}
			centeredMessage={true}
			actionOne={this.actionSelected.bind(this, buttons[0])}
			actionTwo={this.actionSelected.bind(this, buttons[1])}
			closeAction={this.actionSelected.bind(this, closeButtonData)} />)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		userUpgradeActionSelected: userActions.userUpgradeActionSelected,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(UpgradeConfirm)
